<template>

  <div class="p-3">

    <div style="overflow: hidden;">
      <div class="row">
        <div class="col-sm">
          
          <div class="card mb-3">
            <div class="card-header">
              {{ $t('General information') }}
            </div>
            <div class="card-body">
                <label><strong>{{ $t('Hiring manager') }}</strong></label>
                <p>{{ job.hiring_manager_name }}, <a :href="'mailto:'+job.hiring_manager_email">{{ job.hiring_manager_email }}</a></p>

                <label><strong>{{ $t('Location') }}</strong></label>
                <p>
                  {{ location || 'N/D' }}
                  <span v-if="job.workplace_type">
                    ({{ $t({ 'on-site': 'On-site', 'remote': 'Remote', 'hybrid': 'Hybrid' }[job.workplace_type]) }})
                  </span>
                </p>
                
                <label><strong>{{ $t('Remuneration') }}</strong></label>
                <p v-if="job.remuneration">
                  <span v-if="job.remuneration">{{ $n(job.remuneration, {style: 'currency', currency: job.currency}) }} </span>
                  <span v-if="job.remuneration_max">até {{ $n(job.remuneration_max, {style: 'currency', currency: job.currency}) }}</span>
                  <span v-if="remunerationPeriod"> ({{ remunerationPeriod }}) </span>
                  <span v-if="job.contract_id">- {{ job.contract_id.name }}</span>
                </p>
                <p v-if="!job.remuneration">{{ 'N/D' }}</p>

                <label><strong>{{ $t('Tags') }}</strong></label>
                <div>
                  <ul
                    class="list-tags"
                    v-if="job.tags && job.tags.length">
                    <li
                      v-for="(tag, index) in job.tags"
                      :key="index">
                      {{ tag }}
                      </li>
                  </ul>
                </div>
                <p v-if="!(job.tags && job.tags.length)">{{ 'N/D' }}</p>
            </div>
          </div>

          <div class="card mb-3">
            <div class="card-header">
              {{ $t('Description') }}
            </div>
            <div class="card-body">
              <div v-html="job.description"></div>
            </div>
            <div class="card-header">
              {{ $t('Requirements') }}
            </div>
            <div class="card-body">
              <div v-html="job.requirements"></div>
            </div>
            <div class="card-header">
              {{ $t('Benefits') }}
            </div>
            <div class="card-body">
              <div v-html="job.benefits"></div>
            </div>
          </div>

          <div class="card mb-3">
            <div class="card-header">
              {{ $t('Comments') }}
            </div>
            <div class="card-body">
              <span style="white-space: pre-wrap;">{{ job.comments }}</span>
            </div>
          </div>

          <custom-view
            :fieldsValue="job.custom_fields" 
            :modelType="'job'">
            </custom-view>

        </div>
        <div class="col-sm">

          <div class="card mb-3">
            <div class="card-header">
              {{ $t('Details') }}
            </div>
            <div class="card-body">

              <label><strong>{{ $t('Professional category') }}</strong></label>
              <p>{{ positionCategory ? positionCategory.name : '--' }}</p>

              <label><strong>{{ $t('Experience level') }}</strong></label>
              <p>{{ experienceLevel ? experienceLevel.name : '--' }}</p>

              <label><strong>{{ $t('Last education') }}</strong></label>
              <p>{{ educationDegree ? educationDegree.name : '--' }}</p>

            </div>
          </div>

          <div class="card mb-3">
            <div class="card-header">
              {{ $t('Control') }}
            </div>
            <div class="card-body">
              <div class="grid-view">

                <label><strong>{{ $t('Owner') }}</strong></label>
                <p v-if="job.owner_user_id">{{ job.owner_user_id.name }}</p>

                <label><strong>{{ $t('Team') }}</strong></label>
                <p v-if="job.team_users">{{ job.team_users.map((user) => { return user.name }).join(', ') }}</p>

                <label><strong>{{ $t('Created at') }}</strong></label>
                <p>{{ $d(new Date(job.created_at), 'short') }} por {{ job.author_user_id.name }}</p>

                <label><strong>{{ $t('Opening date') }}</strong></label>
                <p>{{ $d(new Date(job.date_open), 'short') }}</p>

                <label><strong>{{ $t('Expected closing date') }}</strong></label>
                <p>{{ $d(new Date(job.date_close), 'short') }}</p>

              </div>

            </div>
          </div>

          <job-profile-requisition>
            </job-profile-requisition>

        </div>
      </div>
    </div>

  </div>

</template>

<script>
import CustomView from '@/components/Parts/CustomView'
import JobProfileRequisition from './JobProfileRequisition'

export default {
  name: 'JobProfile',
  components: {
    CustomView,
    JobProfileRequisition
  },
  data () {
    return {
    }
  },
  computed: {
    resources () {
      return this.$store.getters.getResources
    },
    job () {
      return this.$store.getters.getJob
    },
    location () {
      return [
        this.job.address,
        this.job.neighborhood,
        this.job.city,
        this.job.region,
        this.job.country,
        this.job.zipcode
      ]
      .filter(v => v)
      .join(', ')
    },
    remunerationPeriod () {
      return {
        hour: this.$t('Hour'),
        month: this.$t('Month'),
        year: this.$t('Year')
      }[this.job.remuneration_period]
    },
    positionCategory () {
      return this.resources.position_category.find((val) => {
        return val.key === this.job.position_category
      })
    },
    experienceLevel () {
      return this.resources.experience_level.find((val) => {
        return val.key === this.job.experience_level
      })
    },
    educationDegree () {
      return this.resources.education_degree.find((val) => {
        return val.key === this.job.education_degree
      })
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobProfile/JobProfile.vue